import moment from 'moment';

function toLocalTime(timeToConvert) {
    return moment.utc(timeToConvert).local().format('YYYY-MM-DDTHH:mm:ss');
}

export const TimeUtil = {
    toLocalTime: toLocalTime,
};
